module.exports = __webpack_public_path__ + "img/faq.08077cf1.jpg";